import React, { useState } from "react";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { HiOutlineLogout } from "react-icons/hi";

const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      // Still navigate to login on error
      navigate("/login");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
  onClick={handleLogout}
  disabled={isLoading}
  className="flex items-center gap-2 rounded-lg bg-red-500 px-8 py-4 text-lg font-semibold text-white transition-colors hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-400"
>
  {isLoading ? "Logging out..." : "Logout"}
  <HiOutlineLogout className="text-xl" />
</button>
  );
};

export default LogoutButton;
